export const stockPercent = (stock, maxStock) => {
  if (!maxStock || maxStock <= 0) return 0;
  return Math.min((stock / maxStock) * 100, 100);
};

export const matchesSearch = (product, term) =>
  product.name.toLowerCase().includes(term.trim().toLowerCase());

export const formatBravos = (amount) => `${amount} Bravos`;
export const formatMXN = (amount) => `$${amount} MXN`;
